// extracted by mini-css-extract-plugin
export default {"list-item":"RbuUC","add-fee-button":"Xm8QC"};